// components/filter/person-filter/person-filter.component.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { db } from "../../../firebase/firebase.utils";

import {
  clearUserFilter,
  setUserFilter,
} from "../../../redux/filter/filter.actions";

import Avatar from "../../retro/avatar/avatar.component";
import HoverDropdown from "../../dropdown/dropdown";

import "./person-filter.styles.scss";

// Keeps already-loaded members available across unmount/remount.
const memberCache = {};

const PersonFilter = () => {
  const spaceId = useSelector((state) => state.history.spaceId);
  const stationId = useSelector((state) => state.history.stationId);
  const filter = useSelector((state) => state.filter);

  const [members, setMembers] = useState(() => memberCache[spaceId] || []);

  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;

    const getMembers = async () => {
      if (!spaceId || !stationId) {
        if (active) setMembers([]);
        return;
      }

      // Immediately restore previously loaded members.
      if (memberCache[spaceId]?.length) {
        setMembers(memberCache[spaceId]);
      }

      const spaceDoc = await db.collection("space").doc(spaceId).get();
      const memberIds = spaceDoc.data()?.members || [];

      const allMembers = await Promise.all(
        memberIds.map(async (memberId) => {
          const memberDoc = await db
            .collection("users")
            .doc(memberId)
            .get();

          return {
            uid: memberId,
            ...memberDoc.data(),
          };
        })
      );

      memberCache[spaceId] = allMembers;

      if (active) {
        setMembers(allMembers);
      }
    };

    getMembers();

    return () => {
      active = false;
    };
  }, [spaceId, stationId]);

  const selectedValue = filter.user || "all";

  const options = useMemo(
    () => [
      {
        value: "all",
        content: (
          <div className="personFilter-option">
            <Avatar />
            <span>Everybody</span>
          </div>
        ),
      },
      ...members.map((member) => ({
        value: member.uid,
        content: (
          <div className="personFilter-option">
            <Avatar src={member.imageUrl} />
            <span>{member.userName}</span>
          </div>
        ),
      })),
    ],
    [members]
  );

  const handleChange = (value) => {
    if (value === "all") {
      dispatch(clearUserFilter());
      return;
    }

    dispatch(setUserFilter(value));
  };

  return (
    <div className="personFilter">
      <HoverDropdown
        options={options}
        value={selectedValue}
        onChange={handleChange}
        hasCaret
        usePortal={false}
        hoverPadding={0}
        buttonTitle="assigned to"
        className={`personFilter-dropdown ${
          selectedValue === "all" ? "is-default" : "is-filtered"
        }`}
      />
    </div>
  );
};

export default PersonFilter;